import React from 'react'

const ContentfulBackButton = (block) => {
    const handleButtonClick = () => {
        window.history.back();
    }

    return (
        <div className="button-wrapper">
            <button onClick={handleButtonClick}>{block.buttonText ? block.buttonText : 'Back'}</button>
        </div>
    )
}

export { ContentfulBackButton }
